import React from 'react';
import UserDetailContainer from './UserDetailContainer';

const UserDetailView = () => {
  return <UserDetailContainer />;
};

export default UserDetailView;
